import { render } from "./HeroiconsOutlineFolderRemove.vue?vue&type=template&id=c700e976"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolderRemove.vue"]])

export default __exports__